(function () {
  'use strict';

  function initialise(root) {
    root.querySelectorAll('[data-ways-delivery-status]').forEach(function (panel) {
      if (panel.dataset.ready === 'true') return;
      var container = panel.closest('.product-form-cart');
      var form = container && container.querySelector('[data-product-form]');
      var source = panel.querySelector('[data-ways-delivery-variants]');
      if (!form || !source) { panel.hidden = true; return; }
      var variants;
      try { variants = JSON.parse(source.textContent); }
      catch (_) { panel.hidden = true; return; }
      if (!Array.isArray(variants)) { panel.hidden = true; return; }
      panel.dataset.ready = 'true';

      function setVariant(variant) {
        panel.hidden = !(variant && variant.available === true && variant.requiresShipping === true);
      }
      function selectedVariant() {
        // The hidden ID can retain its previous value for an invalid combination.
        // Match the actual option selectors first, so stale IDs cannot show delivery.
        var selectors = Array.from(form.querySelectorAll('select[name^="options["]'));
        if (selectors.length) {
          return variants.find(function (variant) {
            return Array.isArray(variant.options) && variant.options.length === selectors.length &&
              selectors.every(function (selector, index) { return selector.value === variant.options[index]; });
          });
        }
        var id = form.querySelector('[name="id"]');
        return id && variants.find(function (variant) { return String(variant.id) === id.value; });
      }
      function sync() { setVariant(selectedVariant()); }
      form.addEventListener('change', sync);
      form.addEventListener('ways:variant-change', function (event) {
        var variant = event.detail && event.detail.variant;
        if (!variant) { setVariant(null); return; }
        var stored = variants.find(function (item) { return String(item.id) === String(variant.id); });
        if (!stored) { setVariant(null); return; }
        // Use the theme's most recent product response when availability changes.
        stored.available = variant.available === true;
        stored.requiresShipping = variant.requires_shipping === true;
        setVariant(stored);
      });
      sync();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialise(document); });
  } else { initialise(document); }
  document.addEventListener('shopify:section:load', function (event) { initialise(event.target); });
})();
